import { SocialShare } from './social-share';

export class FacebookShare extends SocialShare {
  protected generateShareUrl(): string {
    return `https://www.facebook.com/sharer.php?u=${encodeURIComponent(this.url)}`;
  }
}
